module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('div', {
    staticClass: "con",
    attrs: {
      "id": "articleMain"
    }
  }, [(_vm.articleInfo.author) ? _c('div', {
    staticClass: "author-container"
  }, [_c('img', {
    staticClass: "author-avatar",
    attrs: {
      "src": _vm.articleInfo.author && _vm.articleInfo.author.avatar,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "author-name"
  }, [_vm._v(_vm._s(_vm.articleInfo.author && _vm.articleInfo.author.name))])]) : _vm._e(), _vm._v(" "), (_vm.articleInfo.text) ? _c('div', {
    staticClass: "article-content",
    domProps: {
      "innerHTML": _vm._s(_vm.articleInfo.text)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isHaveMedia && _vm.isHaveMedia.media && _vm.isHaveMedia.media.photo && _vm.isHaveMedia.media.photo.length) ? _c('div', {
    staticClass: "img-wrap"
  }, _vm._l((_vm.isHaveMedia.media.photo), function(item) {
    return _c('div', {
      key: item.original.url,
      staticClass: "img-container"
    }, [_c('img', {
      staticClass: "article-img",
      attrs: {
        "src": item.original.url
      }
    })])
  })) : _vm._e(), _vm._v(" "), (_vm.isHaveMedia && _vm.isHaveMedia.media && _vm.isHaveMedia.media.video) ? _c('div', {
    staticClass: "video-wrap"
  }, [(_vm.checkMode(_vm.isHaveMedia && _vm.isHaveMedia.media && _vm.isHaveMedia.media.video)) ? _c('section', {
    staticClass: "video"
  }, [_c('video', {
    style: ('background:url(' + _vm.isHaveMedia && _vm.isHaveMedia.media && _vm.isHaveMedia.media.video.cover + ') top center no-repeat rgba(0,0,0,0.7);background-size: cover;height:' + _vm.video_height + 'px'),
    attrs: {
      "src": _vm.isHaveMedia && _vm.isHaveMedia.media && _vm.isHaveMedia.media.video.url,
      "controls": "controls"
    },
    on: {
      "play": function($event) {
        _vm.videoPlay()
      }
    }
  })]) : _c('div', [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), (_vm.isHaveMedia && _vm.isHaveMedia.media && _vm.isHaveMedia.media.video.cover) ? _c('div', {
    staticClass: "media-container media-container-video",
    style: ({
      'backgroundImage': 'url(' + _vm.isHaveMedia && _vm.isHaveMedia.media && _vm.isHaveMedia.media.video.cover + ')',
      'height': _vm.video_height + 'px'
    }),
    on: {
      "click": function($event) {
        _vm.videoPlay(_vm.isHaveMedia && _vm.isHaveMedia.media && _vm.isHaveMedia.media.video.url)
      }
    }
  }, [_c('div', {
    staticClass: "media-holder media-holder-video"
  })]) : _c('div', {
    staticClass: "media-container media-container-video",
    style: ({
      'height': _vm.video_height + 'px'
    }),
    on: {
      "click": function($event) {
        _vm.videoPlay(_vm.isHaveMedia && _vm.isHaveMedia.media && _vm.isHaveMedia.media.video.url)
      }
    }
  }, [_c('div', {
    staticClass: "media-holder media-holder-video"
  })])])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-000a5c89","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tweetCon.vue
// module id = 902
// module chunks = 7